import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import { DateTime } from 'scaleflow/utils/date-time';
import type InitiativeModel from './initiative';

export default class InitiativeDocumentVersionModel extends Model {
  declare [Type]: 'initiative-document-version';
  @belongsTo('initiative', {
    async: true,
    inverse: 'document_versions',
  })
  declare initiative: AsyncBelongsTo<InitiativeModel>;
  @attr('string') declare text: string;
  @attr declare text_delta: unknown;
  @attr declare created_at: string;

  get formattedCreatedAt() {
    return DateTime.from(this.created_at).format('DD MMM, hh:mm A, YYYY');
  }
}
